export default "__VITE_ASSET__CTtrXzMe__"